/**
 * General Services class
 */
import RestClient from '../Client/RestClient'
import Configuration from '../Api/Configuration'
import { formatRoute } from 'react-router-named-routes'

const { Admin_EndPoints } = Configuration

class AuthServices {

  // static login (data, setFormLoading, FormikActions, defaultErrorMessage = '') {
  //   return RestClient.postRequest(Configuration.BASE_AUTH_URL + Admin_EndPoints.login, data, null, setFormLoading, null, FormikActions, defaultErrorMessage)
  // }

  static getCurrentUser (defaultErrorMessage = '') {
    return RestClient.getRequest(Configuration.BASE_AUTH_URL + Admin_EndPoints.Auth.getUser, null, defaultErrorMessage, true)
  }

  static getCurrentTaxpayer (defaultErrorMessage = '') {
    return RestClient.getRequest(Configuration.BASE_AUTH_URL + Admin_EndPoints.Auth.getCurrentTaxpayer, null, defaultErrorMessage, true)
  }

  static getCurrentTaxpayerSubscriptions (trn, config = null, defaultErrorMessage = '') {
    return RestClient.getRequest(Configuration.BASE_AUTH_URL + formatRoute(Admin_EndPoints.Auth.getCurrentTaxpayerSubscriptions, { trn: trn }), config, defaultErrorMessage, true)
  }

  static getReceiverDetails (trn, defaultErrorMessage = '') {
    if (!!trn) {
      return RestClient.getRequest(Configuration.BASE_AUTH_URL + Admin_EndPoints.Auth.getTaxpayerDetails, { params: { trn: trn } }, defaultErrorMessage)
    }
  }

  static refreshToken () {
    const formData = new FormData()
    formData.append('grant_type', 'client_credentials')
    formData.append('client_id', Configuration.API_CLIENT)
    formData.append('client_secret', Configuration.API_CLIENT_SECRET)
    formData.append('scope', 'InvoicingAPI')
    return RestClient.postRequest(Configuration.BASE_AUTH_URL + Admin_EndPoints.login, formData, null, null, null, null, '')
  }
}

export default AuthServices
